import { HttpClient } from '@angular/common/http';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf
} from '@angular/core';
import { Configuration } from './configuration';

import { AddressControllerService } from './api/addressController.service';
import { AdminControllerService } from './api/adminController.service';
import { ArticleControllerService } from './api/articleController.service';
import { BadgeControllerService } from './api/badgeController.service';
import { BeautyProfileAdminControllerService } from './api/beautyProfileAdminController.service';
import { BeautyProfileControllerService } from './api/beautyProfileController.service';
import { BfluenceIntegrityControllerService } from './api/bfluenceIntegrityController.service';
import { BillingControlControllerService } from './api/billingControlController.service';
import { BlacklistControllerService } from './api/blacklistController.service';
import { BrandControllerService } from './api/brandController.service';
import { CacheControllerService } from './api/cacheController.service';
import { CampaignControllerService } from './api/campaignController.service';
import { CatalogControllerService } from './api/catalogController.service';
import { CompositionControllerService } from './api/compositionController.service';
import { CompositionDashboardControllerService } from './api/compositionDashboardController.service';
import { CouponControllerService } from './api/couponController.service';
import { CouponPriceChangeControllerService } from './api/couponPriceChangeController.service';
import { CourseControllerService } from './api/courseController.service';
import { CustomQueryControllerService } from './api/customQueryController.service';
import { EditionControllerService } from './api/editionController.service';
import { EmailTemplateControllerService } from './api/emailTemplateController.service';
import { ErpControllerService } from './api/erpController.service';
import { FeedbackAdminControllerService } from './api/feedbackAdminController.service';
import { FeedbackControllerService } from './api/feedbackController.service';
import { FeedbackGroupControllerService } from './api/feedbackGroupController.service';
import { FileControllerService } from './api/fileController.service';
import { FinancialAdminControllerService } from './api/financialAdminController.service';
import { FinancialControllerService } from './api/financialController.service';
import { GcpDatabaseUserControllerService } from './api/gcpDatabaseUserController.service';
import { GiftCycleControllerService } from './api/giftCycleController.service';
import { GoogleLoginControllerService } from './api/googleLoginController.service';
import { InfluencerControllerService } from './api/influencerController.service';
import { IntegrationControllerService } from './api/integrationController.service';
import { IntegrationTokenControllerService } from './api/integrationTokenController.service';
import { ItOpsControllerService } from './api/itOpsController.service';
import { KpiControllerService } from './api/kpiController.service';
import { LiveControllerService } from './api/liveController.service';
import { MarketingControllerService } from './api/marketingController.service';
import { MgmConfigControllerService } from './api/mgmConfigController.service';
import { MgmDashboardControllerService } from './api/mgmDashboardController.service';
import { MovementControllerService } from './api/movementController.service';
import { NotificationControllerService } from './api/notificationController.service';
import { OpenControllerService } from './api/openController.service';
import { OrdersControllerService } from './api/ordersController.service';
import { PaymentControllerService } from './api/paymentController.service';
import { PaymentRoundControllerService } from './api/paymentRoundController.service';
import { PersonControllerService } from './api/personController.service';
import { ProductControllerService } from './api/productController.service';
import { ResendDashboardControllerService } from './api/resendDashboardController.service';
import { RewardControllerService } from './api/rewardController.service';
import { SecretsControllerService } from './api/secretsController.service';
import { ShippingCompanyControllerService } from './api/shippingCompanyController.service';
import { ShippingOrderControllerService } from './api/shippingOrderController.service';
import { ShopOrderControllerService } from './api/shopOrderController.service';
import { SmsAnalyticsControllerService } from './api/smsAnalyticsController.service';
import { SubscriberControllerService } from './api/subscriberController.service';
import { SubscriptionControllerService } from './api/subscriptionController.service';
import { SubscriptionTypeControllerService } from './api/subscriptionTypeController.service';
import { SubscriptionTypePriceControllerService } from './api/subscriptionTypePriceController.service';
import { SubscriptionTypeTaxControllerService } from './api/subscriptionTypeTaxController.service';
import { UserControllerService } from './api/userController.service';
import { WebsocketControllerService } from './api/websocketController.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    AddressControllerService,
    AdminControllerService,
    ArticleControllerService,
    BadgeControllerService,
    BeautyProfileAdminControllerService,
    BeautyProfileControllerService,
    BfluenceIntegrityControllerService,
    BillingControlControllerService,
    BlacklistControllerService,
    BrandControllerService,
    CacheControllerService,
    CampaignControllerService,
    CatalogControllerService,
    CompositionControllerService,
    CompositionDashboardControllerService,
    CouponControllerService,
    CouponPriceChangeControllerService,
    CourseControllerService,
    CustomQueryControllerService,
    EditionControllerService,
    EmailTemplateControllerService,
    ErpControllerService,
    FeedbackAdminControllerService,
    FeedbackControllerService,
    FeedbackGroupControllerService,
    FileControllerService,
    FinancialAdminControllerService,
    FinancialControllerService,
    GcpDatabaseUserControllerService,
    GiftCycleControllerService,
    GoogleLoginControllerService,
    InfluencerControllerService,
    IntegrationControllerService,
    IntegrationTokenControllerService,
    ItOpsControllerService,
    KpiControllerService,
    LiveControllerService,
    MarketingControllerService,
    MgmConfigControllerService,
    MgmDashboardControllerService,
    MovementControllerService,
    NotificationControllerService,
    OpenControllerService,
    OrdersControllerService,
    PaymentControllerService,
    PaymentRoundControllerService,
    PersonControllerService,
    ProductControllerService,
    ResendDashboardControllerService,
    RewardControllerService,
    SecretsControllerService,
    ShippingCompanyControllerService,
    ShippingOrderControllerService,
    ShopOrderControllerService,
    SmsAnalyticsControllerService,
    SubscriberControllerService,
    SubscriptionControllerService,
    SubscriptionTypeControllerService,
    SubscriptionTypePriceControllerService,
    SubscriptionTypeTaxControllerService,
    UserControllerService,
    WebsocketControllerService
  ]
})
export class ApiModule {
  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
  public static forRoot(
    configurationFactory: () => Configuration
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }]
    };
  }
}
